import React from 'react'
import classes from "./AiInnovation.module.scss"
import { ReactComponent as AiCloudParks } from "../../../assets/icons/AiCloudParks.svg"
import { ReactComponent as AiIaas } from "../../../assets/icons/AiIaas.svg"
import { ReactComponent as AiVerticalStacks } from "../../../assets/icons/AiVerticalStacks.svg"

const AiInnovation = () => {
    return (
        <div className={classes['ai-innovation-container']}>
            <div className={classes['ai-innovation-image']}>
                <img src={"https://se-website-image.s3.ap-south-1.amazonaws.com/ai-innovation.png"} alt="" className={classes["image-ai"]} />
                <div className={classes['image-text']}>
                    Our <br /> <span>AI-driven innovations</span> for a Brighter Future
                </div>
            </div>
            <div className={classes['energy-solution-card-container']}>
                <div className={classes['ai-cloud-parks-container']}>
                    <div className={classes['logo-conatiner']}>
                        <div className={classes['logo-frame']}>
                            <div className={classes['logo-inside-frame']}>
                                <AiCloudParks />
                            </div>
                        </div>
                    </div>
                    <div className={classes['content-container']}>
                        <div className={classes['content-heading']}>AI Cloud Parks</div>
                        <div className={classes['content-body']}>Developing AI cloud parks powered by clean energy, ensuring sustainability meets high-performance computing.</div>
                    </div>

                </div>
                <div className={classes['ai-iaas-container']}>
                    <div className={classes['logo-conatiner']}>
                        <div className={classes['logo-frame']}>
                            <div className={classes['logo-inside-frame']}>
                                <AiIaas />
                            </div>
                        </div>
                    </div>
                    <div className={classes['content-container']}>
                        <div className={classes['content-heading']}>AI Infrastructure as a Service</div>
                        <div className={classes['content-body']}>Building world-class AI infrastructure — including AI cloud data centers — and offering scalable infrastructure services to global clients.</div>
                    </div>

                </div>
                <div className={classes['ai-vertical-stacks-container']}>
                    <div className={classes['logo-conatiner']}>
                        <div className={classes['logo-frame']}>
                            <div className={classes['logo-inside-frame']}>
                                <AiVerticalStacks />
                            </div>
                        </div>
                    </div>
                    <div className={classes['content-container']}>
                        <div className={classes['content-heading']}>AI Vertical Stacks</div>
                        <div className={classes['content-body']}>Creating specialized AI vertical stacks by customizing open-source and proprietary LLMs into tailored AI agents designed for specific industry use cases.</div>
                    </div>

                </div>
            </div>
            <div className={classes['empowering-ai-container']}>
                <div className={classes['empowering-ai-heading']}>Empowering AI with Clean Energy</div>
                <div className={classes['empowering-ai-body']}>Our objective is to drive the next generation of AI infrastructure, powered by sustainable energy. Through CLEM.ai, we source the most optimal clean energy mix to fuel our AI cloud parks. From developing advanced data centers to enabling sector-specific AI applications, our mission is to push the boundaries of AI innovation — sustainably and efficiently.</div>
            </div>
        </div>
    )
}

export default AiInnovation